module.exports = "//static.hsappstatic.net/connect-dot-com-public-ui/static-1.1590/images/highlightedMembers/dharmesh-shah.png"